import type { HTMLAttributes } from 'react';

const ExpandArrowIcon = () => (
  <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0L5 5L10 0H0Z" fill="#1F1F1F" />
  </svg>
);

export type ExpandDropdownIconProps = {
  isOpen: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const ExpandDropdownIcon = ({ isOpen, ...props }: ExpandDropdownIconProps) => (
  <div
    {...props}
    className={`dropdown-icon-arrow ${isOpen ? 'opened' : ''} ${props.className || ''}`}
  >
    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0L5 5L10 0H0Z" fill="rgb(153, 161, 168)" />
    </svg>
  </div>
);

export default ExpandArrowIcon;
